export function prepareUrl(url, api) {
    Object.keys(api).forEach((k) => {
        url = url.replace('#' + k + '#', api[k]);
    });

    return url;
}

export function deleteItems(container) {
    while (container.firstChild) {
        container.removeChild(container.firstChild);
    }
}

export function showItem(id) {
    setTimeout(function () {
        const item = document.querySelector(`[data-item="${id}"]`);
        if (item) {
            item.classList.add('shownow');
        }

        jQuery(window).trigger('restUpdatedItems');
    }, 100);
}

export function finish(parent) {
    const btnLoadMore = parent.querySelector('[data-loadmore]');

    if (btnLoadMore) {
        jQuery(btnLoadMore).hide();
    }
}
